interface CnBLadySVGprops {
  height: string;
  width: string;
}

export default function CnBLadySVG(props: CnBLadySVGprops) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width}
      height={props.height}
      viewBox="0 0 180 208"
      fill="none"
    >
      <g clipPath="url(#lzfuvy8kva)">
        <path
          d="M134.479 72.085H32.927A27.582 27.582 0 0 1 13.46 64.01a27.56 27.56 0 0 1-8.077-19.46V32.115a27.56 27.56 0 0 1 8.077-19.46 27.582 27.582 0 0 1 19.468-8.073H146.92a27.583 27.583 0 0 1 19.468 8.073 27.56 27.56 0 0 1 8.077 19.46 40.012 40.012 0 0 1-11.725 28.249 40.04 40.04 0 0 1-28.262 11.72z"
          fill="#fff"
          stroke="#E5E9EB"
          strokeWidth="2"
        />
        <path
          d="M108.283 22.315H41.155a1.448 1.448 0 1 1 0-2.894h67.128a1.45 1.45 0 0 1 1.448 1.447 1.449 1.449 0 0 1-1.448 1.447zM142.265 37.755H41.155a1.448 1.448 0 1 1 0-2.895h101.11a1.446 1.446 0 0 1 1.023 2.47 1.445 1.445 0 0 1-1.023.425zM142.265 53.194H41.155a1.448 1.448 0 1 1 0-2.894h101.11a1.445 1.445 0 0 1 1.023 2.47 1.445 1.445 0 0 1-1.023.424z"
          fill="#E6E6E6"
        />
        <path
          d="M142.265 53.194H41.155a1.448 1.448 0 1 1 0-2.894h101.11a1.445 1.445 0 0 1 1.023 2.47 1.445 1.445 0 0 1-1.023.424z"
          fill="#E6E6E6"
        />
        <path
          d="M101.2 39.527a2.982 2.982 0 0 0 3.614 2.806l5.521 9.053 2.35-4.984-5.603-7.833a2.999 2.999 0 0 0-3.367-2.133 3.002 3.002 0 0 0-2.515 3.09z"
          fill="#FEDBDB"
        />
        <path
          d="m142.629 65.473-19.026-10.316-6.001-5.628s-2.609-.698-1.648-1.546c.96-.848-1.776-1.666-1.776-1.666l-3.222-3.021-4.578 3.237 1.325 2.053s-.091 3.399 1.771 2.745c1.863-.654 1.398 2.165 1.398 2.165l11.116 17.225 20.641-5.248z"
          fill="#FC4C4C"
        />
        <path
          d="M86.468 55.754c10.263 0 18.583-8.317 18.583-18.576 0-10.26-8.32-18.577-18.583-18.577-10.263 0-18.583 8.317-18.583 18.577 0 10.259 8.32 18.576 18.583 18.576z"
          fill="#0BEC9F"
        />
        <path d="M142.688 200.778h-3.864l-1.839-14.898h5.703v14.898z" fill="#FEDBDB" />
        <path
          d="M144.727 207.47h-2.771l-.494-2.615-1.267 2.615h-7.349c-.353 0-.696-.113-.98-.321a1.649 1.649 0 0 1 .041-2.689l5.869-4.052v-2.644l6.173.368.778 9.338z"
          fill="#002035"
        />
        <path d="M111.784 200.778h-3.864l-1.839-14.898h5.703v14.898z" fill="#FEDBDB" />
        <path
          d="M113.823 207.47h-2.771l-.494-2.615-1.267 2.615h-7.349a1.653 1.653 0 0 1-1.562-2.19 1.65 1.65 0 0 1 .623-.82l5.869-4.052v-2.644l6.173.368.778 9.338z"
          fill="#002035"
        />
        <path d="M138.588 88.105h-19.503v22.194h19.503V88.105z" fill="#FEDBDB" />
        <path
          d="m119.535 99.052-3.3 3.899-5.701 11.997-14.364 34.164-3.038 7.225 2.453 12.773s.397 8.998.397 10.471c0 2.999 2.51 4.661 2.51 4.661l1.841 9.586 17.852-.75s-.623-10.566-4.362-13.231c-3.739-2.665-5.458-16.555-5.458-16.555l-2.032-6.162 19.803-23.465.128 8.202.062 3.97s-2.9 25.821.48 30.833c3.38 5.011.069 4.421.069 4.421l.161 10.337 21.153.15-4.667-29.761s-2.37-1.87-1.102-3.75-1.229-4.182-1.229-4.182l1.12-23.234s-1.24-4.013.219-4.534c1.458-.522.191-3.973.191-3.973l.217-4.497-4.351-13.946-19.052-4.65z"
          fill="#002035"
        />
        <path
          d="m138.888 88.105 2.1-6.299 1.5-2.1.6-5.998c0-16.195-3.614-13.498-3.614-13.498l-2.086-5.697-9.602-.3-6.15 5.849-5.101 1.8-1.997 10.374 3.647 11.07.9 5.998c-1.717 3.169-1.572 1.67-.15 4.05l16.952 4.648c6.001 2.1 6.001-3.299 4.798-4.649-1.203-1.35-1.797-5.248-1.797-5.248z"
          fill="#FC4C4C"
        />
        <path
          d="M131.346 52.2c4.916 0 8.901-3.983 8.901-8.897s-3.985-8.897-8.901-8.897c-4.915 0-8.9 3.983-8.9 8.897s3.985 8.897 8.9 8.897z"
          fill="#FEDBDB"
        />
        <path
          d="M143.229 55.18a1.09 1.09 0 0 1-.609 1.598c-1.194.396-1.929 1.55-2.787 2.474-.855.92-2.232 1.686-3.325 1.059-1.089-.624-1.164-2.217-2.076-3.08-.888-.84-2.364-.738-3.408-.1l-.031.02a1.104 1.104 0 0 1-1.615-.492 1.098 1.098 0 0 1-.069-.627l1.097-5.834a19.63 19.63 0 0 1-4.108 6.208 4.522 4.522 0 0 1-1.782 1.254c-.624.198-1.23-.447-1.836-.33 1.506-1.317 6.571-9.757 5.664-15.398l-3.195.36a2.937 2.937 0 0 0-.714-1.347c.043.49-.019.984-.183 1.449-.444.05-.891.099-1.335.15-.618.068-1.29.128-1.821-.195-.886-.54-.913-1.818-.661-2.826.739-2.93 2.977-5.38 5.716-6.664 2.739-1.28 3.55 1.572 6.436.66 5.701-1.8 10.069 1.278 11.608 6.988 1.294 4.79.354 9.873-.966 14.672z"
          fill="#002035"
        />
        <path
          d="M167.87 207.663h-10.898l-.047-.084c-.14-.253-.274-.521-.4-.796-1.122-2.402-1.597-5.15-2.016-7.574l-.315-1.828a1.13 1.13 0 0 1 1.777-1.104 3492.83 3492.83 0 0 0 4.971 3.611c.627.457 1.344.985 2.031 1.556.066-.321.135-.644.204-.962a1.13 1.13 0 0 1 2.063-.357l1.275 2.048c.93 1.496 1.751 2.97 1.584 4.559a.278.278 0 0 1-.004.058 3.59 3.59 0 0 1-.186.765l-.039.108z"
          fill="#F0F0F0"
        />
        <path
          d="M178.809 207.899 75.244 208a.392.392 0 0 1 0-.782l103.565-.101a.39.39 0 0 1 .275.116.39.39 0 0 1-.275.666z"
          fill="#CACACA"
        />
        <path
          d="m84.779 62.18-11.392-9.617a1.925 1.925 0 0 1-.229-2.71l2.097-2.482a1.926 1.926 0 0 1 2.712-.229l11.391 9.617a1.925 1.925 0 0 1 .229 2.71l-2.097 2.482a1.927 1.927 0 0 1-2.711.229z"
          fill="#FC4C4C"
        />
        <path
          d="M73.984 50.053a1.037 1.037 0 0 0 .124 1.46l11.391 9.617a1.039 1.039 0 0 0 1.462-.123l2.096-2.482a1.038 1.038 0 0 0-.123-1.46l-11.392-9.617a1.038 1.038 0 0 0-1.46.123l-2.098 2.482z"
          fill="#fff"
        />
        <path
          d="M80.672 53.791a.438.438 0 0 1-.346.183l-1.79.041a.438.438 0 1 1-.02-.875l1.17-.027-1.152-3.042a.438.438 0 0 1 .819-.31l1.372 3.62a.439.439 0 0 1-.046.4l-.007.01z"
          fill="#0BEC9F"
        />
        <path
          d="M80.902 54.556a2.985 2.985 0 0 1 2.397 3.897l8.403 6.47-5.212 1.793-7.18-6.42a3 3 0 0 1 1.592-5.74z"
          fill="#FEDBDB"
        />
        <path
          d="m124.648 57.755-21.513 13.222s-8.675-3.208-6.98-4.693c1.696-1.485-3.7-2.49-3.7-2.49l-5.962-4.009-3.46 4.02s.63 6.527 1.703 5.397 2.676 1.957 2.676 1.957.473 3.448 3.526 2.58c3.054-.867 11.246 8.227 11.246 8.227l26.477-9.87-4.013-14.341z"
          fill="#FC4C4C"
        />
        <path
          d="M85.814 44.63a1.607 1.607 0 0 1-1.285-.643l-3.94-5.252a1.608 1.608 0 0 1 .321-2.248 1.607 1.607 0 0 1 2.25.321l2.577 3.435 6.62-9.927a1.607 1.607 0 0 1 2.674 1.782l-7.88 11.816a1.608 1.608 0 0 1-1.292.715h-.045z"
          fill="#fff"
        />
      </g>
      <defs>
        <clipPath id="lzfuvy8kva">
          <path fill="#fff" transform="translate(.801)" d="M0 0h178.397v208H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
